import { render, staticRenderFns } from "./addskugoods.vue?vue&type=template&id=8dfa0a08&scoped=true&"
import script from "./addskugoods.vue?vue&type=script&lang=js&"
export * from "./addskugoods.vue?vue&type=script&lang=js&"
import style0 from "./addskugoods.vue?vue&type=style&index=0&id=8dfa0a08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfa0a08",
  null
  
)

export default component.exports